import script from "./DiffLifeCycleCostModelling.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiffLifeCycleCostModelling.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__